// Static data used across frontend
export const CASTELLI = [
  "Tutti i Castelli",
  "Città di San Marino",
  "Serravalle",
  "Borgo Maggiore",
  "Domagnano",
  "Faetano",
  "Fiorentino",
  "Acquaviva",
  "Chiesanuova",
  "Montegiardino"
];

export const CATEGORIES = [
  { id: "auto", name: "Auto e Vetture", icon: "Car", color: "bg-sky-100 text-sky-700" },
  { id: "elettronica", name: "Elettronica", icon: "Smartphone", color: "bg-blue-100 text-blue-600" },
  { id: "casa", name: "Casa e Arredamento", icon: "Sofa", color: "bg-amber-100 text-amber-700" },
  { id: "moda", name: "Moda e Accessori", icon: "Shirt", color: "bg-pink-100 text-pink-600" },
  { id: "sport", name: "Sports e Hobby", icon: "Dumbbell", color: "bg-green-100 text-green-600" },
  { id: "moto", name: "Moto e Ciclomotori", icon: "Bike", color: "bg-red-100 text-red-700" },
  { id: "agricoli", name: "Mezzi Agricoli", icon: "Tractor", color: "bg-lime-100 text-lime-800" },
  { id: "collezionismo", name: "Collezionismo", icon: "Trophy", color: "bg-amber-100 text-amber-800" },
  { id: "bambini", name: "Tutto per i Bambini", icon: "Baby", color: "bg-yellow-100 text-yellow-700" },
  { id: "lavoro", name: "Offerte di Lavoro", icon: "Briefcase", color: "bg-slate-100 text-slate-700" },
  { id: "immobili", name: "Immobili", icon: "Home", color: "bg-orange-100 text-orange-600" },
  { id: "servizi", name: "Servizi", icon: "Wrench", color: "bg-purple-100 text-purple-600" },
  { id: "animali", name: "Animali", icon: "PawPrint", color: "bg-teal-100 text-teal-600" },
  { id: "musica", name: "Musica e Film", icon: "Music", color: "bg-red-100 text-red-600" },
  { id: "libri", name: "Libri e Riviste", icon: "BookOpen", color: "bg-indigo-100 text-indigo-600" },
  { id: "giardino", name: "Giardino e Fai da te", icon: "Trees", color: "bg-lime-100 text-lime-700" }
];

export const CONDITIONS = ["Nuovo", "Come nuovo", "Ottimo", "Buono", "Accettabile"];
